import { tap } from 'rxjs/operators';
import { SIGN_IN, SIGN_OUT } from '@enauka/shared/infrastructure/auth/data-access';
import { Injectable } from '@angular/core';
import { KonfiguracjaDto, OsobaControllerService } from '@enauka/api';
import { EventsService } from '@enauka/shared/infrastructure/events';
import { ReplaySubject, Subscription } from 'rxjs';

const PUSTA_KONFIGURACJA = { pola: {} };
export class Konfiguracja {
  constructor(private konfiguracja: KonfiguracjaDto, public bladInicjalizacji = false) { }

  get(nazwa: string): string {
    if (this.konfiguracja) {
      return this.konfiguracja.pola[nazwa]
    }
    return null;
  }

  getBoolean(nazwa: string): boolean {
    return this.get(nazwa) === "true";
  }

  getInt(nazwa: string): number {
    return parseInt(this.get(nazwa), 10);
  }

}

@Injectable()
export class KonfiguracjaService {
  private konfiguracja = new ReplaySubject<Konfiguracja>(1);

  constructor(private eventsService: EventsService,
    private osobaControllerService: OsobaControllerService) {
    this.eventsService.on(SIGN_IN, () => {
      this.init();
    });
    this.eventsService.on(SIGN_OUT, () => {
      this.close();
    });
  }

  init() {
    this.osobaControllerService.getKonfiguracjaUsingGET()
      .subscribe(dto => this.konfiguracja.next(new Konfiguracja(dto)));
  }

  initPromise(): Promise<KonfiguracjaDto> {
    return this.osobaControllerService.getKonfiguracjaUsingGET()
      .pipe(
        tap(dto => {
          this.konfiguracja.next(new Konfiguracja(dto))
        }, (err) => {
          this.konfiguracja.next(new Konfiguracja(PUSTA_KONFIGURACJA, true));
        })
      )
      .toPromise().then((r) => r, (r) => {
        return PUSTA_KONFIGURACJA;
      });
  }

  pustaKonfiguracja(): Promise<KonfiguracjaDto> {
    this.konfiguracja.next(new Konfiguracja(PUSTA_KONFIGURACJA, false));
    return Promise.resolve(PUSTA_KONFIGURACJA);
  }

  subscribe(next?: (value: Konfiguracja) => void): Subscription {
    return this.konfiguracja.subscribe(next);
  }

  close() {
  }

}
